import React from 'react';
import { Row, Col, Card } from 'antd';
import './FeatureGrid.css';

interface FeatureItem {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureGrid: React.FC = () => {
  const features: FeatureItem[] = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      ),
      title: '专业团队',
      description: '10年装修经验，专业设计师和施工团队，从设计到施工全程把控'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      ),
      title: '品质保证',
      description: '严格的质量控制体系，使用优质材料，确保装修质量'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      ),
      title: '价格透明',
      description: '明码标价，无隐形消费，让您每一分钱都花得明白'
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <h2 className="section-title">为什么选择同步到家</h2>
        <p className="section-subtitle">专业团队，品质保证，价格透明，售后无忧</p>

        <Row gutter={[32, 32]}>
          {features.map((feature, index) => (
            <Col key={index} xs={24} sm={12} lg={8}>
              <Card
                className="feature-card"
                variant="borderless"
                hoverable
              >
                <div className="feature-icon">{feature.icon}</div>
                <div className="feature-text-content">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default FeatureGrid;
